"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Autocomplete", {
  enumerable: true,
  get: function get() {
    return _Autocomplete["default"];
  }
});
exports.AutocompleteSelect = void 0;
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function get() {
    return _Autocomplete.createFilterOptions;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _Autocomplete = _interopRequireWildcard(require("@material-ui/lab/Autocomplete"));
var _Input = require("../../Input");
var _AutoCompleteSelect = require("./AutoCompleteSelect.styles");
var _excluded = ["renderInput", "getOptionLabel", "renderOption"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return option.label;
};
var AutocompleteSelect = /*#__PURE__*/(0, _react.memo)(function (props) {
  var _useStyles = (0, _AutoCompleteSelect.useStyles)(),
    optionClassName = _useStyles.option,
    img = _useStyles.img;
  var defaultRenderInput = (0, _react.useCallback)(function (params) {
    return /*#__PURE__*/_react["default"].createElement(_Input.Input, _extends({
      testId: "autocomplete-select-params",
      fullWidth: true
    }, params, {
      inputProps: params.inputProps,
      label: props.label
    }));
  }, [props.label]);
  var defaultRenderOption = (0, _react.useCallback)(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: optionClassName
    }, option.img && /*#__PURE__*/_react["default"].createElement("span", {
      className: img
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: option.img,
      alt: option.label,
      width: "20"
    })), /*#__PURE__*/_react["default"].createElement("span", null, option.label));
  }, [optionClassName, img]);
  var _props$renderInput = props.renderInput,
    renderInput = _props$renderInput === void 0 ? defaultRenderInput : _props$renderInput,
    _props$getOptionLabel = props.getOptionLabel,
    getOptionLabel = _props$getOptionLabel === void 0 ? defaultGetOptionLabel : _props$getOptionLabel,
    _props$renderOption = props.renderOption,
    renderOption = _props$renderOption === void 0 ? defaultRenderOption : _props$renderOption,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    renderInput: renderInput,
    getOptionLabel: getOptionLabel,
    renderOption: renderOption
  }, rest));
});
exports.AutocompleteSelect = AutocompleteSelect;